import { transformWithSpec } from "../../../utils/response.js";
function infoEndpoints(builder) {
  return {
    getInfo: builder.query({
      providesTags: ["info"],
      query: ({ accountId }) => ({
        url: `/info?account=${accountId}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  infoEndpoints as default
};
